import styled from "styled-components";

const KidsChartWrap = styled.div`
  padding: 52px 0 32px;
  text-align: center;
  img {
    width: 100%;
    max-width: 1100px;
    margin-bottom: 32px;
  }
  p {
    text-align: left;
  }
`

export default KidsChartWrap